var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mission-ranking-period-parts"},[_c('span',[_vm._v(_vm._s(_vm.$tc('MissionPage.RankingPage.aggregationPeriod'))+"：")]),_c('span',[_vm._v(_vm._s(_vm.periodData))])])}
var staticRenderFns = []

export { render, staticRenderFns }